/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.LineElevationRequest = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The LineElevationRequest model module.
   * @module model/LineElevationRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>LineElevationRequest</code>.
   * The request object includes the Well Known Text (WKT), srid, the length of segment, the unit of segment and the unit of the elevation.
   * @alias module:model/LineElevationRequest
   * @class
   * @param wellKnownText {String} Required. The Well Known Text (WKT) of the feature to get the elevation from.
   */
  var exports = function(wellKnownText) {
    var _this = this;

    _this['wellKnownText'] = wellKnownText;





  };

  /**
   * Constructs a <code>LineElevationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LineElevationRequest} obj Optional instance to populate.
   * @return {module:model/LineElevationRequest} The populated <code>LineElevationRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('wellKnownText')) {
        obj['wellKnownText'] = ApiClient.convertToType(data['wellKnownText'], 'String');
      }
      if (data.hasOwnProperty('srid')) {
        obj['srid'] = ApiClient.convertToType(data['srid'], 'Number');
      }
      if (data.hasOwnProperty('numberOfSegments')) {
        obj['numberOfSegments'] = ApiClient.convertToType(data['numberOfSegments'], 'Number');
      }
      if (data.hasOwnProperty('elevationUnit')) {
        obj['elevationUnit'] = ApiClient.convertToType(data['elevationUnit'], 'String');
      }
      if (data.hasOwnProperty('intervalDistance')) {
        obj['intervalDistance'] = ApiClient.convertToType(data['intervalDistance'], 'Number');
      }
      if (data.hasOwnProperty('intervalDistanceUnit')) {
        obj['intervalDistanceUnit'] = ApiClient.convertToType(data['intervalDistanceUnit'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The Well Known Text (WKT) of the feature to get the elevation from.
   * @member {String} wellKnownText
   */
  exports.prototype['wellKnownText'] = undefined;
  /**
   * The SRID (coordinate system) of the WellKnownText.
   * @member {Number} srid
   */
  exports.prototype['srid'] = undefined;
  /**
   * Splits the requested line into this many segments, then calculates elevation of each point joining the segments
   * @member {Number} numberOfSegments
   */
  exports.prototype['numberOfSegments'] = undefined;
  /**
   * The unit of measure in which the elevation should be expressed.
   * @member {module:model/LineElevationRequest.ElevationUnitEnum} elevationUnit
   */
  exports.prototype['elevationUnit'] = undefined;
  /**
   * Splits the requested line into intervals of this length. The unit of measure for this distance is specified by the IntervalDistanceUnit parameter.
   * @member {Number} intervalDistance
   */
  exports.prototype['intervalDistance'] = undefined;
  /**
   * The unit of measure in which the <para>IntervalDistance</para> is expressed. Defaults to \"Feet\".
   * @member {module:model/LineElevationRequest.IntervalDistanceUnitEnum} intervalDistanceUnit
   */
  exports.prototype['intervalDistanceUnit'] = undefined;


  /**
   * Allowed values for the <code>elevationUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ElevationUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };

  /**
   * Allowed values for the <code>intervalDistanceUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.IntervalDistanceUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };


  return exports;
}));



